import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Consegne esterne',
  fields: {
    pickup: 'Ritiro',
    dropoff: 'Consegna',
    status: 'Stato',
    estimated_time: 'Tempo stimato',
    actual_time: 'Tempo effettivo',
    actions: 'Azioni',
    time: 'Ora',
    pickup_estimate: 'Stima ritiro',
    dropoff_estimate: 'Stima consegna',
  },
  labels: {
    pickup: 'Ritiro',
    dropoff: 'Consegna',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Autista in attesa',
    [DeliveryStatus.RunnerAssigned]: 'Autista assegnato',
    [DeliveryStatus.OnRoutePickup]: 'In viaggio per il ritiro',
    [DeliveryStatus.ArrivedPickup]: 'Arrivato al ritiro',
    [DeliveryStatus.PickedUp]: 'Ritirato',
    [DeliveryStatus.OnRouteDropoff]: 'In viaggio per la consegna',
    [DeliveryStatus.ArrivedDropoff]: 'Arrivato alla consegna',
    [DeliveryStatus.Completed]: 'Completato',
    [DeliveryStatus.Cancelled]: 'Annullato',
  },
  buttons: {
    actions: 'Azioni',
    open_tracking_url: 'Traccia consegna',
    show_order_details: 'Mostra dettagli ordine',
    call_restaurant: 'Chiama il ristorante',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
